import {
  FileMinusIcon,
  FilePenIcon,
  FilePlusIcon,
  FileSymlinkIcon,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { FileChangeEventView } from '@/lib/api/generated/model';

/**
 * What each kind of recorded change is called, and the mark it carries.
 *
 * Lifted out of `HistoryEntry` when Overview grew a change feed of its own.
 * Two surfaces reading one log had to name its events identically or the
 * workspace would appear to have had different things happen to it depending
 * on which page you asked — the same reason Overview reuses the board's words
 * for task state rather than inventing its own.
 */
export const FILE_EVENT: Record<
  FileChangeEventView['event_type'],
  { label: string; icon: LucideIcon }
> = {
  created: { label: 'Created', icon: FilePlusIcon },
  modified: { label: 'Modified', icon: FilePenIcon },
  deleted: { label: 'Deleted', icon: FileMinusIcon },
  // A move is one event naming two paths, not a deletion followed by an
  // unrelated arrival — so it reads as "Moved" and keeps the file's history
  // continuous across it (spec 059 FR-013).
  moved: { label: 'Moved', icon: FileSymlinkIcon },
};
